import React, { useEffect, useState } from 'react';
import PersonSelect from '../PersonSelect';
import useApiStable from '../../utils/useApiStable';
import '../../styles/TaskList.css';

function WorkDutyAppointmentForm({ appointment, onClose }) {
  const [title, setTitle] = useState(appointment?.title || '');
  const [description, setDescription] = useState(appointment?.description || '');
  const [date, setDate] = useState(appointment?.date || '');
  const [timeFrom, setTimeFrom] = useState(appointment?.timeFrom?.substring(0, 5) || '');
  const [timeTo, setTimeTo] = useState(appointment?.timeTo?.substring(0, 5) || '');
  const [responsiblePersonId, setResponsiblePersonId] = useState(appointment?.responsiblePersonId || '');
  const [minParticipants, setMinParticipants] = useState(appointment?.minParticipants ?? 1);
  const [persons, setPersons] = useState([]);
  const [loadingPersons, setLoadingPersons] = useState(false);
  const [saving, setSaving] = useState(false);
  const [cancelling, setCancelling] = useState(false);
  const [error, setError] = useState('');

  const api = useApiStable();

  useEffect(() => {
    setLoadingPersons(true);
    api.get('/persons')
      .then(data => setPersons(Array.isArray(data) ? data : []))
      .catch(err => setError(err.message || 'Fehler beim Laden der Personen'))
      .finally(() => setLoadingPersons(false));
  }, []); // eslint-disable-line

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    const payload = {
      title,
      description,
      date,
      timeFrom: timeFrom ? `${timeFrom}:00` : null,
      timeTo: timeTo ? `${timeTo}:00` : null,
      responsiblePersonId: responsiblePersonId ? Number(responsiblePersonId) : null,
      minParticipants: Number(minParticipants),
    };
    setSaving(true);
    const request = appointment
      ? api.put(`/workduty/appointments/${appointment.id}`, payload)
      : api.post('/workduty/appointments', payload);
    request
      .then(() => onClose(true))
      .catch(err => setError(err.message || 'Fehler beim Speichern des Termins'))
      .finally(() => setSaving(false));
  };

  const handleCancel = () => {
    if (!appointment?.id) return;
    if (!window.confirm('Diesen Arbeitsdienst-Termin wirklich absagen?')) return;
    setError('');
    setCancelling(true);
    api.delete(`/workduty/appointments/${appointment.id}`)
      .then(() => onClose(true))
      .catch(err => setError(err.message || 'Fehler beim Absagen des Termins'))
      .finally(() => setCancelling(false));
  };

  return (
    <div className="taskform-card">
      <h3 style={{ marginBottom: '18px' }}>{appointment ? 'Termin bearbeiten' : 'Neuen Arbeitsdienst-Termin anlegen'}</h3>
      {error && <div className="taskform-error">{error}</div>}
      <form onSubmit={handleSubmit} className={saving ? 'taskform-loading' : ''}>
        <div className="taskform-group">
          <label htmlFor="wd-title">Titel *</label>
          <input id="wd-title" value={title} onChange={e => setTitle(e.target.value)} required disabled={saving} />
        </div>
        <div className="taskform-group">
          <label htmlFor="wd-desc">Beschreibung</label>
          <textarea id="wd-desc" value={description} onChange={e => setDescription(e.target.value)} disabled={saving} />
        </div>
        <div className="taskform-inline-row">
          <div className="taskform-group">
            <label htmlFor="wd-date">Datum *</label>
            <input id="wd-date" type="date" value={date} onChange={e => setDate(e.target.value)} required disabled={saving} />
          </div>
          <div className="taskform-group">
            <label htmlFor="wd-from">Von *</label>
            <input id="wd-from" type="time" value={timeFrom} onChange={e => setTimeFrom(e.target.value)} required disabled={saving} />
          </div>
          <div className="taskform-group">
            <label htmlFor="wd-to">Bis</label>
            <input id="wd-to" type="time" value={timeTo} onChange={e => setTimeTo(e.target.value)} disabled={saving} />
          </div>
        </div>
        <div className="taskform-inline-row">
          <div className="taskform-group">
            <PersonSelect persons={persons} value={responsiblePersonId} label="Verantwortlicher *"
                          onChange={setResponsiblePersonId} single disabled={saving || loadingPersons} />
          </div>
          <div className="taskform-group">
            <label htmlFor="wd-min">Mindestanzahl *</label>
            <input id="wd-min" type="number" min="0" value={minParticipants}
                   onChange={e => setMinParticipants(e.target.value)} required disabled={saving} />
          </div>
        </div>
        <div className="taskform-actions" style={{ marginTop: '6px' }}>
          {appointment && appointment.id && (
            <button type="button" className="taskform-delete-btn" onClick={handleCancel}
                    disabled={saving || cancelling} style={{ marginRight: 'auto', background: '#dc3545', color: '#fff' }}>
              {cancelling ? 'Sage ab...' : 'Termin absagen'}
            </button>
          )}
          <button type="button" className="taskform-cancel-btn" onClick={() => onClose(false)} disabled={saving || cancelling}>Abbrechen</button>
          <button type="submit" className="taskform-save-btn" disabled={saving || cancelling || loadingPersons || !title}>
            Speichern
          </button>
        </div>
      </form>
    </div>
  );
}

export default WorkDutyAppointmentForm;
